import useStyles from "./GlobalScoreEsgGaugeStyle";
import EAIcon from "components/common/EAIcon";

const GlobalScoreEsgGauge = ({score}) => {
    const { classes } = useStyles();

    const getGaugeImage = (value) => {
        switch(value) {
            case "1" : 
                return `esg_gauge_very_good`;
            case "2":
                return `esg_gauge_good`;
            case "3":
                return `esg_gauge_medium`;
            case "4":
                return `esg_gauge_bad`;
            default:
                return `esg_gauge_very_bad`;
        }
      };

    return (
        <div className={classes.globalScoreWrapper}>
            <div className={classes.globalScoreChart}>
                <EAIcon icon={`esg/${getGaugeImage(score)}`} style={{scale: "1.1"}} />
                <div className={classes.globalScore}>
                <span className="score">{score}</span>
                <span className="max-score">/5</span>
                </div>
            </div>
            <div className={classes.globalScoreDivider}></div>
        </div>
    )
}

export default GlobalScoreEsgGauge;